<template>
    <div v-if="isTranslationRequired()" class="translate-detected" @click="activeAutoTranslate">
        {{
            $t("message.autoTranslateDetectedDesc", {
                visitorLanguage: getVisitorLanguage(),
            })
        }}
    </div>
</template>
<script>
import languages from "../../language/languages.json";
import * as _ from "lodash";
import { PERMISSION_TYPES } from "../../language/permissionTypes";
import { mapState } from "vuex";

export default {
    name: "TranslateDetected",
    props: {
        contact: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            autoTranslate: (state) => state.chat.autoTranslate,
            user: (state) => state.auth.user,
            settings: (state) => state.setting.settings,
        }),
    },
    methods: {
        getVisitorLanguage() {
            const language = languages.find((x) => x.code === this.contact.preferredLang);
            return language?.originalName || this.contact.preferredLang;
        },
        isWebChat() {
            return !(
                this.contact.lastConversation.whatsappNumber ||
                this.contact.lastConversation.instagramUserId ||
                this.contact.lastConversation.messengerUserId ||
                this.contact.lastConversation.telegramUserId
            );
        },
        isTranslationRequired() {
            const isActive = this.autoTranslate.includes(this.contact.lastConversation._id);
            const preferredLang = _.get(this.contact, "preferredLang");
            if (!preferredLang) return false;
            const langIsDifferent = this.user.lang !== preferredLang;
            const isWebChat = this.isWebChat();
            const isEnabledFromSettings = this.settings.autoTranslate;
            return isEnabledFromSettings && !isActive && langIsDifferent && isWebChat;
        },
        activeAutoTranslate() {
            this.$emit("auto-translate", true);
        },
    },
};
</script>
<style scoped>
.translate-detected {
    background: #f2f4f7;
    color: #22272d;
    cursor: pointer;
    padding: 0.6rem;
    position: absolute;
    width: 100%;
    z-index: 1 !important;
    text-decoration: underline;
}
</style>
